// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1YOcU","ranges":"BmiRanges_ranges__1dtjQ"};